import React, { Component } from "react";
import { withRouter } from "react-router";

class BottomMenu extends Component {
  render() {
    const { menu, handleToggleDrawer } = this.props;
    return (
      <div
        style={{
          width: "20%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#181818",
        }}
        onClick={
          menu.url
            ? () => this.props.history.push(menu.url)
            : handleToggleDrawer
        }
      >
        {menu.icon}
        {menu.status ? (
          <div style={{ fontWeight: "bold" }}>{menu.name}</div>
        ) : (
          <div>{menu.name}</div>
        )}
      </div>
    );
  }
}

export default withRouter(BottomMenu);
